"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeFocusListener = exports.isHidden = exports.addFocusListener = void 0;
var hidden = "";
var visibilityChange = "";
function addFocusListener(listener) {
    if (typeof document.hidden !== "undefined") {
        // Opera 12.10 and Firefox 18 and later support
        hidden = "hidden";
        visibilityChange = "visibilitychange";
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
    }
    else if (typeof document.msHidden !== "undefined") {
        hidden = "msHidden";
        visibilityChange = "msvisibilitychange";
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
    }
    else if (typeof document.webkitHidden !== "undefined") {
        hidden = "webkitHidden";
        visibilityChange = "webkitvisibilitychange";
    }
    if (typeof document.addEventListener === "undefined" || typeof document.hidden === "undefined") {
        console.warn("focus/blur changes on tab require Google Chrome or Firefox"); // eslint-disable-line
    }
    else {
        document.addEventListener(visibilityChange, listener, false);
    }
}
exports.addFocusListener = addFocusListener;
function removeFocusListener(listener) {
    try {
        document.removeEventListener(visibilityChange, listener, false);
    }
    catch (error) {
        // Do nothing
    }
}
exports.removeFocusListener = removeFocusListener;
function isHidden() {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return document[hidden];
}
exports.isHidden = isHidden;
//# sourceMappingURL=module.js.map